import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type HomeDownload = { id: number; name: string; attachment: { url: string }[] }

export function useHomeDownload() {
  return useFetch<HomeDownload>(getAbsoluteServerUrl('/resources?last=1'), { responseType: 'json' }, [])
}
